import { categories, navItems, siteMeta } from '@/mocks/homeContent';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="container-x grid grid-cols-1 gap-10 py-12 md:grid-cols-[1.4fr_1fr_1fr] md:py-14">
        <div className="flex flex-col gap-4">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
              <i className="ri-message-2-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-black tracking-wide text-background-50">{siteMeta.brand}</span>
          </a>
          <p className="max-w-sm text-sm leading-7 text-background-100/70">
            聚焦搭讪博主测评、盘点、排行、对比与吐槽避雷的中文内容观察站，帮你快速锁定值得关注的社交表达与搭讪沟通创作者。
          </p>
          <div className="flex items-center gap-3 text-sm">
            <a href="mailto:hello@dashanchigua.example" className="inline-flex items-center gap-1.5 hover:text-background-50">
              <i className="ri-mail-line" aria-hidden="true"></i>
              编辑部邮箱
            </a>
          </div>
        </div>

        <nav aria-label="页脚导航">
          <h4 className="mb-4 text-sm font-bold text-background-50">内容栏目</h4>
          <ul className="flex flex-col gap-2.5">
            {navItems.map((n) => (
              <li key={n.id}>
                <a href={`#${n.id}`} className="text-sm text-background-100/70 transition hover:text-background-50">
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="板块导航">
          <h4 className="mb-4 text-sm font-bold text-background-50">六大板块</h4>
          <ul className="flex flex-col gap-2.5">
            {categories.map((c) => (
              <li key={c.name}>
                <a href={`#${c.target}`} className="text-sm text-background-100/70 transition hover:text-background-50">
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-background-700">
        <div className="container-x flex flex-col items-start justify-between gap-3 py-5 sm:flex-row sm:items-center">
          <p className="text-xs text-background-100/60">
            © {year} {siteMeta.brand} · 编辑向内容站 · 榜单与测评均为编辑部独立观点，供内容选择参考。
          </p>
          <p className="text-xs text-background-100/50">
            <a href="#top" className="inline-flex items-center gap-1 hover:text-background-50">
              <i className="ri-arrow-up-line" aria-hidden="true"></i> 返回顶部
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}